import asyncComponent from "../AsyncComponent";

export const PdfPage = asyncComponent(() => {
  return import("./PdfReader" /* webpackChunkName: "PdfReader" */);
});
